<template>
  <div class="progress">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'数据统计'},{name:'综合进度'}]"></breadcrumb>
    <div class="progress-wrap">
      <div class="progress-contain">
        <data-top-nav></data-top-nav>
        <div class="progress-search_wrap">
          <el-select v-model="channel"
                     @change="channelChange"
                     placeholder="请选择">
            <el-option v-for="item in this.channelList"
                       :key="item.code"
                       :label="item.desc"
                       :value="item.code"></el-option>
          </el-select>
          <el-select v-model="limit"
                     style="width:140px"
                     @change="limitChange"
                     placeholder="请选择">
            <el-option v-for="item in this.limitList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
          <el-select v-model="weidu"
                     @change="weiduChange"
                     placeholder="请选择">
            <el-option v-for="item in this.weiduList"
                       :key="item.code"
                       :label="item.desc"
                       :value="item.code"></el-option>
          </el-select>
          <div class="cms-select_month">
            <el-date-picker @change="monthChange"
                            v-model="month"
                            type="month"
                            placeholder="选择年月"></el-date-picker>
          </div>
        </div>
        <div class="progress-contant_wrap">
          <div class="progress-table-wrap">
            <div class="progress-table_title">
              <span v-if="month">{{tableTitle}}</span>
               <div class="progress-table_title_right">
              <div class="progress-table_download">
                <font-awesome-icon style="color:#F0722B;margin-right:10px"
                                   :icon="['fas', 'download']" />报表下载
              </div>
              <div class="progress-table_bar" @click="showChart" v-if="limit!==45">
                <font-awesome-icon
                                   :icon="['fas', 'chart-bar']" />
              </div>
               </div>
            </div>
            <div class="progress-table">
              <table>
                <tr>
                  <th>序号</th>
                  <th>{{weiduName}}</th>
                  <th>户数进度</th>
                  <th>cms进度</th>
                  <th>综合进度</th>
                </tr>
                <tr v-for="(item,index) in list"
                    :key="item.id">
                  <td>{{index +1}}</td>
                  <td>{{item.name}}</td>
                  <td>{{item.mnClient}}%</td>
                  <td>{{item.mnCsm}}%</td>
                  <td>{{item.mnIntegrated.toFixed(2)}}%</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
      <el-dialog
      class="static-chart"
      :title="chartTitle"
      :visible.sync="optionVisible"
      :width="width+20+'px'"
    >
      <v-chart
      theme="dark"
        v-if="optionVisible"
        :style="{width:width+'px'}"
        :options="option"
        style="height:500px"
      ></v-chart>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/servies/axios'
import api from '@/servies/api'
import breadcrumb from '@/components/breadcrumb'
import dataTopNav from '@/components/dataTopNav'
import ECharts from 'vue-echarts'
import 'echarts'
import moment from 'moment'
import _ from 'lodash'
export default {
  components: {
    breadcrumb,
    dataTopNav,
    'v-chart': ECharts
  },
  data() {
    return {
      width:'',
      channel: '',
      channelName: '',
      limit: '',
      limitName: '',
      weidu: '',
      weiduName: '',
      month: '',

      limitList: [],
      channelList: [],
      weiduList: [],

      list: [],

          optionVisible: false,
      chartTitle: "",
      tableTitle:""
    }
  },
  created() {
    Promise.all([
      this.getLimitList(),
      this.getWeiduList(),
      this.getChannelList()
    ])
      .then(() => {
        this.limitChange()
      })
      .catch(error => {
        console.log(error)
        this.$message.error('网络错误，稍后重试')
      })
  },
   computed: {
    xlist() {
      let list = _.cloneDeep(this.list)
      if (
          list[list.length - 1].name === '总计')
      {
        list.pop()
      }
      return list
    }
  },
  methods: {
    //初始化时间
    initDate() {
      this.month = new Date()
    },
    allList() {
      switch (this.limit) {
        case 46:
          this.limitName = '年度任务综合'
          this.getIntegratedYearProcess()
          break
        case 47:
          this.limitName = '月任务综合'
          this.getIntegratedMonthProcess()
          break
      }
    },
    getLimitList() {
      for (let item1 of this.$store.state.menuList) {
        if (item1.id === 50) {
          let list = item1.children
          for (let item2 of list) {
            if (item2.id === 31) {
              this.limitList = item2.children
              this.limit = this.limitList[0].id
              this.limitName = this.limitList[0].name
            }
          }
        }
      }
    },
    getChannelList() {
     return axios.get(api.getChannelTypeList).then(res => {
        if (res.data.code === 0) {
          console.log('获取台类型成功', res.data.result)
          this.channelList = res.data.result
          this.channel = this.channelList[0].code
          this.channelName = this.channelList[0].desc
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getWeiduList() {
     return axios.get(api.getWeiduList).then(res => {
        if (res.data.code === 0) {
          console.log('获取维度类型成功', res.data.result)
          this.weiduList = res.data.result
          this.weidu = this.weiduList[1].code
          this.weiduName = this.weiduList[1].desc
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //频道改变
    channelChange(channelCode) {
      switch (channelCode) {
        case 0:
          this.channelName = '中文台'
          break
        case 1:
          this.channelName = '资讯台'
          break
      }
      this.limitChange()
    },
    //维度改变
    weiduChange() {
      switch (this.weidu) {
        case 3:
          this.weiduName = '个人'
          break
        case 2:
          this.weiduName = '省份'
          break
        case 1:
          this.weiduName = '代表处'
          break
      }
      this.allList()
    },
    //年选择框改变
    monthChange(v) {
      this.allList()
    },
    //获取的列表改变
    limitChange() {
      this.initDate()
      this.allList()
    },
    //年度任务综合
    getIntegratedYearProcess() {
      this.tableTitle =
        this.month.getFullYear() +
        '年' +
        (this.month.getMonth() + 1) +
        '月 年度任务综合详情--【' +
        this.channelName +
        '】-【' +
        this.weiduName +
        '】'
      let params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.month.getFullYear(),
        month: this.month.getMonth() + 1
      }
      axios
        .post(api.getIntegratedYearProcess, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('全年年度任务综合成功', res.data.result)
            this.list = res.data.result
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    },
    //月任务综合
    getIntegratedMonthProcess() {
      this.tableTitle =
        this.month.getFullYear() +
        '年' +
        (this.month.getMonth() + 1) +
        '月月任务综合详情--【' +
        this.channelName +
        '】-【' +
        this.weiduName +
        '】'
      let params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.month.getFullYear(),
        month: this.month.getMonth() + 1
      }
      axios
        .post(api.getIntegratedMonthProcess, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('月任务综合成功', res.data.result)
            this.list = res.data.result
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    },
    showChart() {
      this.width = this.list.length * 20 < 500 ? 500 : this.list.length * 20;
      this.chartTitle =
         this.month.getFullYear() +
        '年' +
        (this.month.getMonth() + 1) +
        '月'+ this.limitName + '各城市对比--【' +
        this.channelName +
        '】-【' +
        this.weiduName +
        '】'
      this.option = {
        legend: {},
        grid: {
          x: 50,
          y: 50,
          x2: 30,
          y2: 120
        },
        tooltip: {},
        xAxis: {
          type: "category",
          data: this.xlist.map(item => {
           return item.name
          }),
          axisLabel: {
            interval: 0,
            formatter: function(value) {
              return value.split("").join("\n");
            },
            textStyle: {
              fontSize: 10 //更改坐标轴文字大小
            }
          }
        },
        yAxis: {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          {
            name:'户数进度',
            type: "bar",
            data: this.xlist.map(item => {
              return item.mnClient
            })
          },
           {
            name:'Cms进度',
            type: "bar",
            data: this.xlist.map(item => {
              return item.mnCsm
            })
          },
          {
            name:'综合进度',
            type: "line",
            data: this.xlist.map(item => {
              return item.mnIntegrated
            })
          }
        ]
      };
      this.optionVisible = true;
    },
  }
}
</script>


<style lang="scss">
.progress {
  .progress-wrap {
    padding: 77px 30px 0px 30px;
    .progress-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .progress-search_wrap {
        display: flex;
        background: #f8f8f8;
        padding: 20px 27px 5px 27px;
        justify-content: flex-start;
        flex-wrap: wrap;
        .el-select {
          width: 108px;
          margin-right: 17px;
          margin-bottom: 15px;
        }
        .el-range-editor {
          margin-right: 17px;
        }
        .progress-button_wrap {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          .el-date-editor {
            width: 108px;
            height: 40px;
          }
        }
        .cms-select_month {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          .el-date-editor {
            width: 120px;
            height: 40px;
          }
        }
        .progress-select_month {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          .el-date-editor {
            width: 120px;
          }
        }
      }
      .progress-contant_wrap {
        padding: 30px;
        .progress-table_title {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 27px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .progress-table_title_right{
            display: flex;
            .progress-table_bar{
                    background: #fff;
              height: 40px;
              width:50px;
              cursor: pointer;
              margin-left: 10px;
              line-height: 40px;
              text-align: center;
                border-radius: 4px;
            border: 1px solid rgba(220, 223, 230, 1);
            color: #9b9b9b;
            }
          .progress-table_download {
            width: 108px;
            height: 40px;
            border-radius: 4px;
            border: 1px solid rgba(220, 223, 230, 1);
            color: #9b9b9b;
            font-size: 14px;
            font-weight: 500;
            line-height: 40px;
            text-align: center;
          }
          }
        }
        .progress-table {
          min-height: 470px;
          tr {
            height: 47px;
            th {
              position: sticky;
              top:113px;
              height: 40px;
              background: #5d5d5d;
              color: #fff;
              a {
                cursor: pointer;
              }
            }
            td {
              text-align: center;
              height: 54px;
              a {
                cursor: pointer;
                color: #f0722b;
              }
              div {
                display: inline-block;
              }
            }
          }
        }
      }
    }
  }
  .progress-chart {
    .el-dialog__body {
      padding-top: 0px;
      padding-bottom: 10px;
      padding-left: 10px;
    }
  }
}
</style>
